import { CreateOrganizationSecretRequestBodySchema } from 'libs/end-to-end/src/types/secrets/create-or-update-organization-secret-request-body';
import { OrganizationSecretItem } from 'libs/end-to-end/src/types/secrets/organization-secret-items';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import { useSimpleWritePattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleWritePattern';
import { OnOrganizationSecretCreateCompleteFn } from 'apps/sigma2-ui/src/secrets/lib/types';
import { OrganizationSecretCreateComponentHook } from 'apps/sigma2-ui/src/secrets/lib/types';

export const useOrganizationSecretCreateComponent = ({
  organizationId,
  onComplete,
}: {
  organizationId: string;
  onComplete: OnOrganizationSecretCreateCompleteFn;
}): OrganizationSecretCreateComponentHook => {
  const writePatternGetUrlFn = useCallback(() => {
    return `${getApiBaseUrl()}/organizations/${organizationId}/secrets`;
  }, [organizationId]);

  const writePattern = useSimpleWritePattern({
    getUrlFn: writePatternGetUrlFn,
    method: 'POST',
    writeSchema: CreateOrganizationSecretRequestBodySchema,
    responseSchema: OrganizationSecretItem,
    canWrite: true,
  });

  useEffect(() => {
    if (
      writePattern.status === 'done' &&
      writePattern.saved &&
      writePattern.entity
    ) {
      onComplete(writePattern.entity.secretId);
    }
  }, [onComplete, writePattern, writePattern.status]);

  const [createSecretDescription, setCreateSecretDescription] =
    useState<string>('');
  const [createSecretValue, setCreateSecretValue] = useState<string>('');

  return useMemo(() => {
    return {
      setCreateSecretValue,
      setCreateSecretDescription,
      createSecretValue,
      createSecretDescription,
      createSecretButtonBehavior: {
        type: 'onClick',
        onClick: () => {
          if (
            writePattern.status !== 'done' &&
            writePattern.status !== 'error'
          ) {
            return;
          }

          if (!createSecretValue) {
            return;
          }

          writePattern.saveEntity({
            secretDescription: createSecretDescription,
            secretValue: createSecretValue,
          });
        },
      },
      createSecretTitle: 'Create Secret',
      createSecretButtonLabel: 'Save',
      createSecretDescriptionLabel: 'Description',
      createSecretValueLabel: 'Value',
      createSecretButtonDisabled: !createSecretValue,
    };
  }, [createSecretDescription, createSecretValue, writePattern]);
};
